/* eslint-disable react/prop-types */
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import SoftBadge from 'components/SoftBadge';
import * as React from 'react';
import { useState } from 'react';
import { useNavigate } from "react-router-dom";
import ellipsis from 'utils/ellipsis';
import fixTableCellWidth from 'utils/fixTableCellWidth';
import Loading from 'components/Loading';
import { deleteMission } from 'services/mission.routes';
import { toast } from 'react-toastify';
import MissionDetailModal from './MissionDetailModal';
import useModal from 'hooks/useModal';

function Row(props) {
    const { row, navigate, handleDeleteMission, updateModal } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ '& > *': { borderBottom: 'unset' }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell" align="left" title={row.name}
                    style={fixTableCellWidth("140px")}>{row.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row?.category?.name}
                    style={fixTableCellWidth("120px")}>{row?.category?.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row?.badge?.name}
                    style={fixTableCellWidth("120px")}>{row?.badge?.name}</TableCell>
                <TableCell className="tablecell" align="left" title={row.description}
                    style={fixTableCellWidth("200px")}>{ellipsis(row.description, 40)}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("150px")}><section style={{ display: "flex", cursor: 'pointer' }}>
                        <SoftBadge variant="contained"
                            onClick={() => updateModal("missionDetail", { state: true, item: row })}
                            badgeContent="اطلاعات بیشتر"
                            size="xs" />
                        <SoftBadge variant="contained"
                            onClick={() => navigate(`/new-mission?method=update`, { state: row })}
                            badgeContent="آپدیت"
                            color="secondary" size="xs" />
                        <SoftBadge variant="contained"
                            badgeContent="حذف" onClick={() => handleDeleteMission(row.id)}
                            color="error" size="xs" />
                    </section>
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}

export default function MissionTable({ data }) {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false);
    const [modals, updateModal, closeModal] = useModal({
        missionDetail: { state: false },
    });
    const closeMissionDetailModal = () => closeModal("missionDetail");

    const handleDeleteMission = (missionId) => {
        let answer = window.confirm("آیا از حذف اطمینان دارید؟");
        if (answer) {
            setLoading(true);
            deleteMission(missionId, (isOk, data) => {
                if (!isOk) {
                    setLoading(false);
                    return toast.error(data.message)
                } else {
                    setLoading(false);
                    toast.success("ماموریت حذف شد!");
                }
            })
        }
    }
    return (
        <>
            <Loading loading={loading} />
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <SoftBadge onClick={() => navigate("/new-mission")} variant="contained"
                            badgeContent="ماموریت جدید" color="success" size="xs"
                            container
                            style={{ cursor: 'pointer' }} />
                        <SoftBadge onClick={() => navigate("/mission-category")} variant="contained"
                            badgeContent="دسته بندی ماموریت" size="xs"
                            container
                            style={{ cursor: 'pointer', marginRight: 10 }} />
                        <SoftBadge onClick={() => navigate("/user-missions")} variant="contained"
                            badgeContent="ماموریت های کاربر" size="xs" color="secondary"
                            container
                            style={{ cursor: 'pointer', marginRight: 10 }} />
                        <TableRow>
                            <TableCell className="tablecell" style={fixTableCellWidth("120px")}>نام</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("120px")}>دسته بندی</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("120px")}>نشان</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("200px")}>توضیحات</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>عملیات</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ display: 'block' }}>
                        {data.map((row) => (
                            <Row key={row.id} row={row} updateModal={updateModal} navigate={navigate} handleDeleteMission={handleDeleteMission} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {modals.missionDetail.state && <MissionDetailModal modalInfo={modals.missionDetail} closeModal={closeMissionDetailModal} />}
        </>
    );
}
